import { MouseEvent } from 'react';

import * as S from './style';

interface Props {
  size?: number;
  thumbnail?: string;
  isNew?: boolean;
  onClick?: (e: MouseEvent) => void;
}

export default function Avatar({ size, thumbnail, isNew, onClick, ...props }: Props) {
  return (
    <S.Wrapper onClick={onClick} {...props}>
      <S.ImageWrapper size={size}>
        {thumbnail && <S.Img src={thumbnail} alt='avatar thumbnail' />}
      </S.ImageWrapper>
      {isNew && <S.RedPoint />}
    </S.Wrapper>
  );
}
